const Form042TC = {
    stepName: {
        Statement: "重要事項",
        PartI: "甲部份",
        PartII: "乙部份",
        PartIII: "丙部份",
        Confirmation: "確認",
    },
    label: {
        applicantOption: {
            individual: "個人名義",
            organisation: "代表機構",
        },
        identityOption: {
            HKIC: "香港身份證",
            passportNo: "護照",
        },
        declareTypeOption: {
            individual: "以本人名義",
            organisation: "代表機構",
        },
        declareTypeOptionPartII: {
            individual: "本人名義",
            organisation: "代表機構",
        },
        // stafPostOption: {
        //     ChildCareSupervisor: "幼兒中心主管",
        //     ChildCareWorker: "幼兒工作員",
        // },
        IsHolderOption: {
            true: "是",
            false: "否",
        },
        workTimeOption: {
            AMWork: "上午",
            PMWork: "下午",
            fullWork: "全職",
        },
        submitOption: {
            submitted: "呈交",
            notYetSubmitted: "未呈交",
        },
        submitOption2: {
            submitted: "呈交",
            notYetSubmitted: "未呈交",
            notApplicable: "不適用 (只提供半日制服務)",
        },
        issuingUnitOption: {
            directorBuilding: "屋宇署",
            directorHousing: "房屋署",
            directorArchitecturalServices: "建築署",
        },
        WROption: {
            WR1: "WR1表格",
            WR2: "WR2表格",
        },
        gasInstallationOption: {
            completion: "完工證明書",
            inspection: "每年檢查／維修證明書",
        },
        titleOption: {
            Mr: "先生",
            Mrs: "夫人",
            Miss: "小姐",
            Ms: "女士",
        },
        note: "重要事項",
        statement: "聲明",
        termsConditions: "本人已閱讀、明白及同意上述條款及細則。",
        termsConditions1: "本人理解申請人需要擁有「智方便+」帳戶才能處理申請。",
        applicationType: "請選擇申請類型：",
        applicationTitle: "申請人稱謂：",
        applicationEnglishName: "申請人姓名（英文）",
        applicationChineseName: "申請人姓名（中文）",
        HKIC: "身份証號碼",
        passportNo: "護照號碼",
        organisationEnglishName: "代表機構名稱（英文）",
        organisationChineseName: "代表機構名稱（中文）",
        addressEnglish: "{{applicationType}}地址（英文）",
        addressChinese: "{{applicationType}}地址（中文）",
        tel: "{{applicationType}}電話號碼",
        fax: "{{applicationType}}傳真號碼",
        isSameAbove: "聯絡人同上",
        contactTitle: "聯絡人稱謂：",
        // contactEnglistName: "聯絡人姓名（英文）",
        // contactChineseName: "聯絡人姓名（中文）",
        contactName: "聯絡人姓名",
        // contactEnglishAddress: "聯絡人地址（英文）",
        // contactChineseAddress: "聯絡人地址（中文）",
        contactAddress: "聯絡人地址",
        contactTel: "聯絡人電話號碼",
        contactFax: "聯絡人傳真號碼",
        contactEmail: "聯絡人電郵地址",
        declareType:
            "根據有關幼兒服務條例第243章第七節，我現以<u>{{type}}</u>申請以下地方為一註冊幼兒中心。",

        registerEnglishName: "擬辦中心名稱（英文）",
        registerChineseName: "擬辦中心名稱（中文）",
        registerEnglishAddress: "擬辦中心詳細地址（英文）",
        registerChineseAddress: "擬辦中心詳細地址（中文）",
        registerTel: "擬辦中心電話號碼",
        registerFax: "擬辦中心傳真號碼",
        registerEmail: "擬辦中心電郵地址",

        sectionOne: "1. 服務類別、建議名額及擬定收費 ",
        sectionTwo: "2. 職員名單：",

        centerType: "中心類別",
        capacityNum: "建議名額",
        crecheGp: "育嬰園（0-2）",
        nurseryGp: "幼兒園（2-3）",
        amProp: "上午",
        pmProp: "下午",
        fullProp: "全日",
        feeNum: "每月擬定收費及期數",
        amFee: "上午（期數）",
        pmFee: "下午（期數）",
        fullFee: "全日（期數）",
        mealCharge: "膳食費（期數）",
        // staffPost: "職位",
        childCareSupervisor: "幼兒中心主管",
        childCareWorker: "幼兒工作員",
        staffEnglishName: "英文姓名",
        staffChineseName: "中文姓名",
        staffHKICNo: "香港身份證號碼",
        workingHours: "選擇工作時間：",
        holderCertificate: "有效急救證書持有人：",
        AidCertificateFile: "附件（急救證書）：",

        sectionThree: "3. 時間表：擬定之日常活動時間表",
        sectionFour1: "4. 膳食份量及菜單",
        sectionFour2: "：擬定之膳食份量及菜單",
        sectionFive: "5. 招生計劃",
        submitChoose: "是否呈交：",
        timeTableFile: "上傳日常活動時間表",
        menuDietaryFile: "上傳膳食份量及菜單表",
        childrenNo: "首階段招收兒童人數",
        staffNo: "首階段幼兒工作職員人數",

        sectionSixHeader: "6. 附上所需證書／文件：",
        sectionSixA: "（a）消防處發出之證書副本",
        sectionSixB: "（b）屋宇署／房屋署／建築署*發出之有關證書副本",
        sectionSixC:
            "（c）有關固定電力裝置之完工證明書（WR1表格）連同電業工程人員註冊證明書和電業承辦商註冊證明書副本各一份及／或*定期測試證明書（WR2表格）副本",
        sectionSixD:
            "（d）有關氣體燃料裝置之「完工證明書」或「每年檢查／維修證明書」*正副本（視乎需要），連同氣體裝置技工註冊咭和氣體工程承辦商註冊證明書副本各一份",
        referenceFire: "編號",
        issueDateFire: "簽發日期",
        fireCertificatFile: "證書：",

        selectUnit: "發出之部門：",
        referenceBuild: "編號",
        issueDateBuild: "簽發日期",
        buildCertificatFile: "證書：",

        // selectWR: "選擇需上傳的文件",
        electricalContractorNo: "承辦商編號",
        completeDate: "簽發日期",
        WCCertificatFile: "有關固定電力裝置之完工證明書（WR1表格)：",
        REWCertificatFile: "電業工程人員註冊證明書：",
        ECCertificatFile: "電業承辦商註冊證明書：",
        PTCCertificatFile: "定期測試證明書（WR2表格）：",

        gasContractorNo: "承辦商編號",
        gasCompleteDate: "簽發日期",
        CGIWCertificatFile:
            "氣體燃料裝置之「完工證明書」或「每年檢查／維修證明書」：",
        // AIMGIWCertificatFile: "有關氣體燃料裝置之「每年檢查/維修證明書」：",
        GIRCRCertificatFile: "氣體裝置技工註冊咭：",
        RGCCRertificatFile: "氣體工程承辦商註冊證明書：",
    },
    errorMsg: {
        propTotal: "建議名額總數必须大于1",
        feeTotal: "擬定收費總數必须大于1",
        addToast: "請先填寫上一名幼兒工作員的資料",
        addToast2: "請先移除空白的幼兒工作員記錄",
        "E-A-001": "只能添加一個主管職位",
    },
    notesList: {
        note1: "請參閱幼兒服務規例第243章第五及第六條",
        note2: "請附上持有人的有效急救證書副本一份",
        // note3: "如中心只提供半日制服務，可免填此項",
    },
    symbolStep: [
        { step: "（a）" },
        { step: "（b）" },
        { step: "（c）" },
        { step: "（d）" },
        { step: "（e）" },
        { step: "（f）" },
        { step: "（g）" },
    ],

    statement: {
        titleList: [{ text: "重要事項" }],
        fourStep: [
            {
                text: "沒有「智方便+」戶口的申請人須把已填妥的申請表交回幼稚園及幼兒中心聯合辦事處處理（地址：香港太古城太古灣道14號6樓602室）。請確保已為郵件支付足夠郵資，以免未能送達本局。郵資不足的郵件，一律會由香港郵政處理。",
            },
        ],
    },
};
export default Form042TC;
